import Box from "@material-ui/core/Box";
import { envSettings } from "core/EnvSettings";
import React from "react";
import { useRecordContext } from "react-admin";

import { BoxMovementsDatagrid } from "./box_movements/BoxMovementsDatagrid";

export const PickingListPalletDetails = ({
	isConfirmBoxMovementMode,
	setIsConfirmBoxMovementMode,
	orderId,
	translate,
	terminalId,
	storagePlaces,
	orderStatus,
	fetchReservationTotals,
}) => {
	const record = useRecordContext();

	if (!envSettings.REACT_APP_FF_STORAGE_MODULE) {
		return null;
	}

	const hasBoxMovements = record?.box_movements?.length > 0;
	if (!hasBoxMovements) {
		return <Box p={2}>{translate("tab.picking_list.box_movement.no_box_movements_available")}</Box>;
	}

	return (
		<Box px={10} py={0.2}>
			<BoxMovementsDatagrid
				translate={translate}
				pallet={record}
				orderId={orderId}
				terminalId={terminalId}
				storagePlaces={storagePlaces}
				isConfirmBoxMovementMode={isConfirmBoxMovementMode}
				setIsConfirmBoxMovementMode={setIsConfirmBoxMovementMode}
				orderStatus={orderStatus}
				fetchReservationTotals={fetchReservationTotals}
			/>
		</Box>
	);
};
